const OPTIONS = [
  { key: "tight", label: "Tight", hint: "Haiku · short" },
  { key: "normal", label: "Normal", hint: "Sonnet · default" },
  { key: "thorough", label: "Thorough", hint: "Sonnet · extended" },
];

export default function LengthDial({ value, onChange, estimate }) {
  return (
    <div className="flex flex-col gap-2">
      <div className="text-[10px] uppercase tracking-[0.15em] text-sage-muted flex justify-between">
        <span>Depth Dial</span>
        {estimate && (
          <span data-testid="length-dial-estimate">
            est. ${estimate.cost_lo?.toFixed(6)}–${estimate.cost_hi?.toFixed(6)} · {estimate.model}
          </span>
        )}
      </div>
      <div className="flex border border-sage-border divide-x divide-sage-border bg-sage-elevated text-xs uppercase w-fit">
        {OPTIONS.map((o) => (
          <button
            key={o.key}
            data-testid={`length-dial-${o.key}`}
            onClick={() => onChange(o.key)}
            className={`px-4 py-2 transition-colors duration-150 ${
              value === o.key
                ? "bg-sage-accent text-sage-bg"
                : "text-sage-muted hover:text-sage-accent"
            }`}
          >
            <div className="font-bold">{o.label}</div>
            <div className="text-[9px] normal-case tracking-normal opacity-70">{o.hint}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
